<app-input-wrapper>
  <div class="input">
    <ng-content></ng-content>
  </div>
</app-input-wrapper>
